import { Inputs } from '@bagonboard/ui-kit';
import { InputAdornment } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import PersonIcon from '@material-ui/icons/Person';
import { FastField, getIn } from 'formik';
import React from 'react';

import {
  FormikInput, FormikSelect, GridContainer, GridItem, PhoneInputContainer, PhoneInputIcon,
} from '../../../../../components';
import { OrderCard } from '../../../components';
// import { ErrorContainer, PhoneContainer, PhoneStyledIcon } from './style';

const { Phone: PhoneInput } = Inputs;

const ClientInformation = () => (
  <OrderCard title="Client information" icon={<PersonIcon />}>
    <GridContainer spacing={4}>
      <GridItem xs={12} sm={12} md={6}>
        <FormikInput
          data-testid="input.client-name"
          name="client.name"
          labelText="Name"
          formControlProps={{ fullWidth: true }}
          inputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <PersonIcon />
              </InputAdornment>
            ),
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FormikInput
          data-testid="input.client-surname"
          name="client.surname"
          labelText="Surname"
          formControlProps={{ fullWidth: true }}
          inputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <PersonIcon />
              </InputAdornment>
            ),
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FastField name="client.phone">
          {({ field, form }) => {
            const phoneError = form.submitCount && getIn(form.errors, field.name);
            return (
              <PhoneInputContainer error={!!phoneError}>
                <PhoneInput
                  id={field.name}
                  {...field}
                  error={phoneError || undefined}
                  placeholder="Phone number"
                  onChange={(value) => {
                    form.setFieldValue(field.name, value);
                    form.setFieldTouched(field.name, true);
                  }}
                  defaultCountry="ES"
                />
                <PhoneInputIcon />
              </PhoneInputContainer>
            );
          }}
        </FastField>
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FormikInput
          data-testid="input.client-email"
          name="client.email"
          labelText="E-mail"
          formControlProps={{ fullWidth: true }}
          inputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <EmailIcon />
              </InputAdornment>
            ),
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FormikSelect
          data-testid="input.client-language"
          name="client.language"
          labelText="Language selector"
          formControlProps={{
            fullWidth: true,
          }}
          options={[{ value: 'en', text: 'English' }, { value: 'es', text: 'Spanish' }]}
        />
      </GridItem>
    </GridContainer>
  </OrderCard>
);

export default ClientInformation;
